/* eslint-disable no-sparse-arrays */
/* eslint-disable no-dupe-keys */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useEffect } from "react";
import { useState, useRef } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
// import admiralmarket from "./../assets/img/brokerlogoclient/Admirals Markets logo.png";
// Import Swiper styles
import fxpro from './../assets/img/broker_logos/fxpro-review.png'

import Select from "react-select";
import { SlClose } from "react-icons/sl";
// import { Navigation } from "swiper";

import "swiper/css/pagination";
// import { Pagination } from "swiper/modules";
import { AiOutlineArrowRight } from "react-icons/ai";
import securites from "./../assets/img/brokerlogoclient/ACY Securities logo.jpg";
import admiralmarket from "./../assets/img/brokerlogoclient/Admirals Markets logo.png";
import avatrade from "./../assets/img/brokerlogoclient/AvaTrade logo.jpg";
import axi from "./../assets/img/brokerlogoclient/Axi logo.png";
import blackbull from "./../assets/img/brokerlogoclient/Blackbull logo.png";
import captial from "./../assets/img/brokerlogoclient/Capital.com logo2.png";
import cityindex from "./../assets/img/brokerlogoclient/City Index logo.png";
import Eightcap from "./../assets/img/brokerlogoclient/EightCap logo.png";
import etoro from "./../assets/img/brokerlogoclient/eToro logo.png";
import forexcom from "./../assets/img/brokerlogoclient/forex.com logo.png";
import fpmarket from "./../assets/img/brokerlogoclient/FP Markets logo.png";
import fusionmarket from "./../assets/img/brokerlogoclient/Fusion Markets logo.jpg";
import fxcmlogo from "./../assets/img/brokerlogoclient/Fxpro logo.svg";
import fxtm from "./../assets/img/brokerlogoclient/FXTM logo2.png";
import globalprime from "./../assets/img/brokerlogoclient/Global Prime Logo.png";
import gomarket from "./../assets/img/brokerlogoclient/Go Markets logo.jpeg";
import HFmarket from "./../assets/img/brokerlogoclient/HF Markets.png";
import Hycmlogo from "./../assets/img/brokerlogoclient/HYCM logo.png";
import ICmarket from "./../assets/img/brokerlogoclient/IC Markets logo2.png";
import IG from "./../assets/img/brokerlogoclient/IG Logo.jpg";
import marketcom from "./../assets/img/brokerlogoclient/Markets.com logo.jpeg";
import monetamarket from "./../assets/img/brokerlogoclient/Moneta Markets logo2.png";
import multibank from "./../assets/img/brokerlogoclient/MultiBank logo.svg";
import oandalogo from "./../assets/img/brokerlogoclient/Oanda Logo.jpg";
import peperstone from "./../assets/img/brokerlogoclient/Pepperstone logo.png";
import swisslogo from "./../assets/img/brokerlogoclient/Swissquote logo.png";
import tickmil from "./../assets/img/brokerlogoclient/Tickmill logo.png";
import tmgm from "./../assets/img/brokerlogoclient/TMGM logo.jpeg";
import tradenation from "./../assets/img/brokerlogoclient/Trade Nation logo.png";
import vintage from "./../assets/img/brokerlogoclient/Vantage logo.png";
import xtm from "./../assets/img/brokerlogoclient/XM logo.jpg";
import activetrade from "./../assets/img/main-icon.jpg";
import plus500 from "./../assets/img/brokerlogoclient/Plus500 logo2.png";
import XTB from "./../assets/img/Xtb-logo.png";
import CMCmarketlogo from "./../assets/img/brokerlogoclient/CMC Markets Logo.png";
// import { LiaGreaterThanSolid, LiaLessThanSolid } from "react-icons/lia";
import { BsCheck2Circle } from "react-icons/bs";
import { LuExternalLink } from "react-icons/lu";
import { BiLeftArrowAlt, BiRightArrowAlt } from "react-icons/bi";

const NewCompareBroker = () => {
  const countries = [
    { value: 'AllCountry', label: 'All Country' },
    { value: 'Afghanistan', label: 'Afghanistan' },
    { value: 'Albania', label: 'Albania' },
    { value: 'Algeria', label: 'Algeria' },
    { value: 'American Samoa', label: 'American Samoa' },
    { value: 'Andorra', label: 'Andorra' },
    { value: 'Angola', label: 'Angola' },
    { value: 'Anguilla', label: 'Anguilla' },
    { value: 'Antigua & Barbuda', label: 'Antigua & Barbuda' },
    { value: 'Argentina', label: 'Argentina' },
    { value: 'Armenia', label: 'Armenia' },
    { value: 'Aruba', label: 'Aruba' },
    { value: 'Australia', label: 'Australia' },
    { value: 'Austria', label: 'Austria' },
    { value: 'Bahrain', label: 'Bahrain' },
    { value: 'Bangladesh', label: 'Bangladesh' },
    { value: 'Belgium', label: 'Belgium' },
    { value: 'Brazil', label: 'Brazil' },
    { value: 'China', label: 'China' },
    { value: 'Cyprus', label: 'Cyprus' },
    { value: 'Denmark', label: 'Denmark' },
    { value: 'Egypt', label: 'Egypt' },
    { value: 'Finland', label: 'Finland' },
    { value: 'France', label: 'France' },
    { value: 'Germany', label: 'Germany' },
    { value: 'Hong Kong', label: 'Hong Kong' },
    { value: 'Ireland', label: 'Ireland' },
    { value: 'Israel', label: 'Israel' },
    { value: 'Italy', label: 'Italy' },
    { value: 'Japan', label: 'Japan' },
    { value: 'Kuwait', label: 'Kuwait' },
    { value: 'Luxembourg', label: 'Luxembourg' },
    { value: 'Netherlands', label: 'Netherlands' },
    { value: 'New Zealand', label: 'New Zealand' },
    { value: 'Oman', label: 'Oman' },
    { value: 'Poland', label: 'Poland' },
    { value: 'Qatar', label: 'Qatar' },
    { value: 'Saudi Arabia', label: 'Saudi Arabia' },
    { value: 'Singapore', label: 'Singapore' },
    { value: 'South Africa', label: 'South Africa' },
    { value: 'Spain', label: 'Spain' },
    { value: 'Sweden', label: 'Sweden' },
    { value: 'Switzerland', label: 'Switzerland' },
    { value: 'United Arab Emirates', label: 'United Arab Emirates' },
    { value: 'United Kingdom', label: 'United Kingdom' }
  ];
  const BrokerDatas = [
    {
      BrokerName: "Plus500",
      Country: [
        "AllCountry",
        "Australia",
        "Argentina",
        "Austria",
        "Andorra",
        'Hong Kong',
        "Bahrain",
        "Cyprus",
        "Denmark",
        "Germany",
        "Ireland",
        "Finland",
        "Israel",
        "Japan",
        "Italy",
        "Kuwait",
        "Luxembourg",
        "Netherlands",
        "New Zealand",
        "Oman",
        "Poland",
        "Qatar",
        "Saudi Arabia",
        "Singapore",
        "South Africa",
        "Sweden",
        "Switzerland",
        "United Arab Emirates",
        "United Kingdom"
      ],

      url: "https://www.plus500.com",
      lose: "82",
      score: "4.6",
      Avaiable: "in pakistan",
      popularity: "11k",
      Updated: "OCT 2023",
      img: plus500,
      tradingfees: [
        {
          OverallScore: "4.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "1H – 1 Day	",
          InactiveFee: 10,
          IslamicAccount: "yes",
          MT4: "no",
          MT5: "no",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "FCA, CySEC, ASIC, FMA, FSCA, MAS, FSA, DFSA",
          Funding_Methods: "Visa/Master Card, Bank Transfer, Skrill",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$100",
          MaximumLeverage:
            "30:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "4.3",
          WebPlatformscore: "4.3",
          metatraderscore: "3.8",
          custumservicescore: "4.3",
          Accountoppeningscore: "3.2",
        },
      ],
    },
    {
      BrokerName: "ActivTrades",
      Country: ['AllCountry', "Egypt", "American Samoa", "Kuwait", "Behrain", "Oman", "Qatar", "Israel", "Algeria", "Israel", "Albania", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Bangladesh", "Armenia", "Aruba", "Australia", "Austria", "Belgium", "China", "Cyprus", "Denmark", "Finland", "France", "Germany", "Greece", "Hong Kong", "Hungary", "Iceland", "Ireland", "Italy", "Luxembourg", "Malta", "Monaco", "Netherlands", "New Zealand", "Norway", "Poland", "Portugal", "Romania", "San Marino", "Saudi Arabia", "Singapore", "Slovakia", "Slovenia", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      lose: "81",
      url: "https://www.activtrades.com",
      score: "4.6",
      Avaiable: "in ind",
      Updated: "OCT 2023",
      img: activetrade,
      tradingfees: [
        {
          OverallScore: "4.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "1H – 1 Day",
          InactiveFee: 10,
          IslamicAccount: "yes",
          MT4: "yes",
          MT5: "yes",
          TradingView: "yes",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "FCA, CSSF, SCB, FCA, CMVM",
          Funding_Methods:
            "Visa/Master Card, Bank Transfer, Skrill, Neteller, Astropay",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$0",
          MaximumLeverage:
            "200:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "No",
          Otherelectronicwallets: "No",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "4.3",
          WebPlatformscore: "4.3",
          metatraderscore: "3.8",
          custumservicescore: "4.3",
          Accountoppeningscore: "3.2",
        },
      ],
    },
    {
      BrokerName: "XTB",
      url: "https://www.xtb.com",
      Country: ['AllCountry',
        'Afghanistan', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda',
        'Argentina', 'Armenia', 'Aruba', 'Austria', 'Bahrain', 'Brazil', 'China',
        'Cyprus', 'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Ireland', 'Israel', 'Italy',
        'Kuwait', 'Luxembourg', 'Netherlands', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore',
        'South Africa', 'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ],
      score: "4.6",
      lose: "76",
      Avaiable: "in sa",
      Updated: "OCT 2023",
      img: XTB,
      tradingfees: [
        {
          OverallScore: "4.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "Depends on method",
          DepositFee: "1 – 2 Days",
          InactiveFee: 10,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "no",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "FCA, KNF, CySEC, DFSA, FSC",
          Funding_Methods: "Visa/Master Card, Bank Transfer, Skrill",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$0",
          MaximumLeverage:
            "30:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "5.0",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "IG",
      url: "https://www.ig.com",
      Country: ['AllCountry',
        'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Argentina',
        'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Brazil', 'China', 'Cyprus',
        'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Japan', 'Kuwait',
        'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Qatar', 'Saudi Arabia', 'Singapore', 'South Africa',
        'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ],
      score: "4.6",
      lose: "71",
      Avaiable: "in was",
      Updated: "OCT 2023",
      img: IG,
      tradingfees: [
        {
          OverallScore: "4.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "	Depends on method and country",
          DepositFee: "2 – 5 Days",
          InactiveFee: 12,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "no",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators:
            "FCA, BaFin, CySEC, FINMA, DFSA, FSCA, MAS, JFSA, ASIC, FMA",
          Funding_Methods: "Visa/Master Card, Bank Transfer",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$50",
          MaximumLeverage:
            "50:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "No",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "5.0",
          WebPlatformscore: "5.0",
          metatraderscore: "yes",
          custumservicescore: "4.6",
          Accountoppeningscore: "4.2",
        },
      ],
    },
    {
      BrokerName: "Pepperstone",
      url: "https://pepperstone.com",
      Country: ['AllCountry',
        'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Ireland', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Brazil', 'China', 'Cyprus',
        'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Kuwait',
        'Luxembourg', 'Netherlands', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore', 'South Africa',
        'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ],
      lose: "74-89",
      score: "4.6",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: peperstone,
      tradingfees: [
        {
          OverallScore: "4.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "	$0",
          DepositFee: "1 – 3 Days",
          InactiveFee: 0,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "yes",
          TradingView: "yes",
          cTrader: "yes",
          capitaliseaiAvailable: "yes",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "yes",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "FCA, ASIC, CySEC, BaFin, DFSA, SCB,CMA",
          Funding_Methods: "Visa/Master Card, Bank Transfer",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$0",
          MaximumLeverage:
            "30:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "FOREX.com",
      url: "https://www.forex.com",
      Country: ['AllCountry', "Israeal ", "American Samoa", "Behrain", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Japan", "Kuwait", "Luxembourg", "Netherlands", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      score: "4.6",
      lose: "75",

      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: forexcom,
      tradingfees: [
        {
          OverallScore: "4.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "1 – 2 Days",
          InactiveFee: 15,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "yes",
          TradingView: "yes",
          cTrader: "no",
          capitaliseaiAvailable: "yes",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "no",
          TradingCenteralAccess: "yes",
        },
      ],
      Safety: [
        {
          Toptierregulators: "	CIRO, CySEC, CIMA, FCA, SFC, FSA, MAS, ASIC",
          Funding_Methods: "Visa/Master Card, Bank Transfer, Skrill, Neteller",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$100",
          MaximumLeverage:
            "400:1",
          PayPalfordeposit: "No",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "5.5",
          Accountoppeningscore: "4.2",
        },
      ],
    },
    {
      BrokerName: "Fxpro",
      url: "https://www.fxpro.com",
      Country: ['AllCountry', "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Italy", "Japan", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      score: "4.6",
      lose: "81.85",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: fxpro,
      tradingfees: [
        {
          OverallScore: "4.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "1 – 2 Days",
          InactiveFee: 15,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "yes",
          TradingView: "no",
          cTrader: "yes",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "no",
          TradingCenteralAccess: "yes",
        },
      ],
      Safety: [
        {
          Toptierregulators: "	CySEC, FCA, SCB, FSCA",
          Funding_Methods:
            "Visa/Master/Maestro Card, Bank Transfer, Skrill, Neteller",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$100",
          MaximumLeverage:
            "200:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "City Index",
      Country: ['AllCountry', "Australia", "United Arab Emirates", "United Kingdom"],
      url: "https://www.cityindex.com",
      score: "4.6",
      lose: "70",

      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: cityindex,
      tradingfees: [
        {
          OverallScore: "4.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "	$0",
          DepositFee: "1 – 2 Days",
          InactiveFee: 15,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "no",
          TradingView: "yes",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "no",
          TradingCenteralAccess: "yes",
        },
      ],
      Safety: [
        {
          Toptierregulators: "	CIRO, ASIC, MAS, FCA, JFSA",
          Funding_Methods: "Visa/Master/Maestro Card, Bank Transfer, Paypal",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$150",
          MaximumLeverage:
            "30:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "CMC Markets",
      url: "https://www.cmcmarkets.com",
      Country: ['AllCountry', "Luxembourg", "Albania", "Israeal", "Algeria", "Italy", 'Hong Kong', "Australia", "Austria", "Bahrain", "Belgium", "Cyprus", "Denmark", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "United Arab Emirates", "United Kingdom"],
      score: "4.6",
      lose: "69",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: CMCmarketlogo,
      tradingfees: [
        {
          OverallScore: "4.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$20",
          DepositFee: "1 – 3 Days",
          InactiveFee: 10,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "no",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "ASIC, FCA, MAS, CIRO, FMA",
          Funding_Methods: "Visa/Master/ Card, Bank Transfer",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$0",
          MaximumLeverage:
            "30:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "Tickmill",
      url: "https://www.tickmill.com",

      Country: ['AllCountry', "Israel", , "Algeria", "Israeal", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      score: "4.6",
      lose: "72",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: tickmil,
      tradingfees: [
        {
          OverallScore: "4.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "	$10",
          DepositFee: "1 – 2 Days",
          InactiveFee: 0,
          IslamicAccount: "yes",
          MT4: "yes",
          MT5: "yes",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "yes",
          AutochartistAccess: "yes",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "FSA, FCA, CySEC, FSCA",
          Funding_Methods: "Visa/Master/ Card, Bank Transfer, Crypto",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$100",
          MaximumLeverage:
            "30:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "Oanda",
      url: "https://www.oanda.com",
      Country: ['AllCountry', "Algeria", "Israel", , "Andorra", "American Samoa", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Ireland", "Israel", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      score: "4.6",
      lose: "74-89",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: oandalogo,
      tradingfees: [
        {
          OverallScore: "4.9",
          FeeScore: "4.9",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$5",
          DepositFee: "1 – 3 Days",
          InactiveFee: 10,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "yes",
          TradingView: "yes",
          cTrader: "yes",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "yes",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "	CIRO, ASIC, FCA, MFSA, FSC-BVI",
          Funding_Methods: "Visa/Master/ Card, Bank Transfer, Skrill, Neteller",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$0",
          MaximumLeverage:
            "888:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "Admirals Markets",
      url: "https://admiralmarkets.com",
      Country: ['AllCountry',
        'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Argentina',
        'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Belgium', 'Brazil', 'China', 'Cyprus',
        'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Kuwait',
        'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore', 'South Africa',
        'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ]

      ,
      score: "4.6",
      lose: "80",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: admiralmarket,
      tradingfees: [
        {
          OverallScore: "4.9",
          FeeScore: "4.8",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "1 – 2 Days",
          InactiveFee: 10,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "yes",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "no",
          TradingCenteralAccess: "yes",
        },
      ],
      Safety: [
        {
          Toptierregulators: "FCA, CySEC, ASIC, JSC, FSCA",
          Funding_Methods: "Visa/Master/ Card, Bank Transfer, Perfect Money",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$100",
          MaximumLeverage:
            "1000:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "eToro",
      url: "https://www.etoro.com",
      Country: ['AllCountry',
        "Australia", "Austria", "Brazil", "Cyprus", "Denmark", "Egypt", "Finland",
        "France", "Germany", "Ireland", "Italy", "Luxembourg", "Netherlands",
        "Norway", "Oman", "Poland", "Qatar", "Singapore", "South Africa",
        "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"
      ],
      lose: "74-89",
      score: "4.6",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: etoro,
      tradingfees: [
        {
          OverallScore: "4.9",
          FeeScore: "4.2",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "	$10",
          DepositFee: "1 – 4 Days",
          InactiveFee: 10,
          IslamicAccount: "no",
          MT4: "no",
          MT5: "no",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "yes",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "CySEC, FCA, ASIC, FSA",
          Funding_Methods:
            "Visa/Master/ Card, Bank Transfer, Skrill, Neteller, Paypal",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$10",
          MaximumLeverage:
            "30:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "Capital.com",
      url: "https://www.capital.com",
      Country: ['AllCountry', "Angola", "Algeria", "Albania", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Brazil", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      score: "4.6",
      lose: "79",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: captial,
      tradingfees: [
        {
          OverallScore: "4.9",
          FeeScore: "4.2",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "1 – 2 Days",
          InactiveFee: 10,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "no",
          TradingView: "yes",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "	FCA, ASIC, CySEC, FSA, SCB",
          Funding_Methods: "Visa/Master/ Card, Bank Transfer, Apple pay",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$20",
          MaximumLeverage:
            "30:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "Swissquote",
      url: "https://en.swissquote.com",
      Country: ['AllCountry',
        "Andorra", "Austria", "Australia", "Brazil", "Egypt", "Albania", "Armenia", "Israeal", "China", "Bahrain", "Argentina", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czech Republic",
        "Denmark", "Estonia", "Finland", "France", "Germany", "Gibraltar", "Greece", "Guernsey", "Hungary",
        "Iceland", "Ireland", "Isle of Man", "Italy", "Jersey", "Kuwait", "Latvia", "Liechtenstein",
        "Lithuania", "Luxembourg", "Malta", "Monaco", "Netherlands", "New Zealand", "Norway", "Oman", "Poland", "Portugal",
        "Qatar", "Romania", "San Marino", "Saudi Arabia", "Slovakia", "Slovenia", "Spain", "Sweden", "Switzerland",
        "United Arab Emirates", "United Kingdom"
      ],
      score: "4.6",
      lose: "77",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: swisslogo,
      tradingfees: [
        {
          OverallScore: "4.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "1 – 5 Days",
          InactiveFee: 0,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "yes",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "	FCA, FINMA, DFSA, SFC, MFSA, MAS, CSSF,",
          Funding_Methods: "Visa/Master/ Card, Bank Transfer",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$1000",
          MaximumLeverage:
            "100:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "IC Markets",
      url: "https://www.icmarkets.com",
      Country: ['AllCountry', "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Iceland", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      score: "4.6",
      lose: "74-32",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: ICmarket,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "1 – 2 Days",
          InactiveFee: 0,
          IslamicAccount: "yes",
          MT4: "yes",
          MT5: "yes",
          TradingView: "no",
          cTrader: "yes",
          capitaliseaiAvailable: "yes",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "yes",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "FSA, CySEC, ASIC",
          Funding_Methods:
            "Visa/Master/ Card, Bank Transfer, Skrill, Neteller, Paypal",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$200",
          MaximumLeverage:
            "500:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "Fusion Markets",
      url: "https://fusionmarkets.com",
      Country: ['AllCountry', "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Israel", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      score: "4.6",
      lose: "74-89",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: fusionmarket,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "Depends on amount",
          DepositFee: "1H – 1 Day",
          InactiveFee: 10,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "yes",
          TradingView: "no",
          cTrader: "yes",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "yes",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "	ASIC, FSA, VFSC",
          Funding_Methods:
            "Visa/Master/ Card, Bank Transfer, Skrill, Neteller, Paypal",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$0",
          MaximumLeverage:
            "500:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "XM",
      url: "https://www.xm.com",
      Country: ['AllCountry', "Algeria", "Andorra", "Angola", "Antigua & Barbuda", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      lose: "74-89",
      score: "4.6",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: xtm,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "	$0",
          DepositFee: "4H – 1 Day",
          InactiveFee: 5,
          IslamicAccount: "yes",
          MT4: "yes",
          MT5: "yes",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "yes",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "ASIC, CySEC, FSC, DFSA",
          Funding_Methods: "Visa/Master/ Card, Bank Transfer, e-Wallets",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$5",
          MaximumLeverage:
            "1000:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "FXCM",
      url: "https://www.fxcm.com",

      Country: ['AllCountry', "Algeria", "Albania", "Andorra", "Denmark", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Egypt", "Finland", "Germany", "Iceland", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      score: "4.6",
      lose: "71",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: fxcmlogo,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "1 – 3 Days",
          InactiveFee: 50,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "no",
          TradingView: "yes",
          cTrader: "no",
          capitaliseaiAvailable: "yes",
          zuluTradeAvaiable: "yes",
          copyTradingAvailable: "no",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "FCA, CySEC, BaFin, ASIC, CIRO, ISA, FSCA",
          Funding_Methods: "Visa/Master/ Card, Bank Transfer, Skrill, Neteller",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$50",
          MaximumLeverage:
            "1000:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "ACY Securities",
      url: "https://acy.com",

      Country: ['AllCountry', "United Arab Emirates", "United Kingdom"],
      score: "4.6",
      lose: "74-89",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: securites,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "2H – 1 Day	",
          InactiveFee: 0,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "yes",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "yes",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "ASIC, FSA	",
          Funding_Methods:
            "Visa/Master/ Card, Bank Transfer, Skrill, Neteller, Crypto",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$50",
          MaximumLeverage:
            "500:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "Global Prime",
      url: "https://www.globalprime.com",

      Country: ['AllCountry', "Qatar", "Hong Kong", "Austria", "Bangladesh", "Denmark", "Behrain", "Belgium", "Cyprus", "Kuwait", "Netherlands", "Ireland", "Israel", "Egypt", "American Samoa", "Aruba", "Armenia", "Antigua & Barbuda", "Angola", "Argentina", "Algeria", "Andorra", "Anguilla", "Poland", "Luxembourg", "Switzerland", "Italy", "Spain", "Israel", "Albania", "Saudi Arabia", "Finland", "United States", "China", "India", "Brazil", "United Kingdom", "Germany", "France", "Australia", "Canada", "Japan", "Sweden", "Sweden"],

      score: "4.6",
      lose: "74-89",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: globalprime,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "1H – 1 Day",
          InactiveFee: 0,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "no",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "yes",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "ASIC, VFSC	",
          Funding_Methods:
            "Visa/Master/ Card, Bank Transfer, Skrill, Neteller, Paypal",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$10",
          MaximumLeverage:
            "200:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "Avatrade",
      url: "https://www.avatrade.com",
      Country: ['AllCountry', "American Samoa", "Albania", "Afghanistan", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Israel", "Italy", "Japan", "Kuwait", "Luxembourg", "Netherlands", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      score: "4.6",
      lose: "76",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: avatrade,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "1 – 3 Days",
          InactiveFee: 50,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "yes",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "yes",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "	FSCA, ASIC, ISA, CySEC, FSA, FSC-BVI",
          Funding_Methods: "Visa/Master/ Card, Bank Transfer, Skrill, Neteller",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$100",
          MaximumLeverage:
            "400:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "FP Markets",
      url: "https://www.fpmarkets.com",
      Country: ['AllCountry', "Qatar", "Behrain", "Egypt", "Kuwait", "Israel", "Algeria", "Oman", "Albania", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Finland", "France", "Germany", "Greece", "Hong Kong", "Hungary", "Iceland", "Ireland", "Italy", "Luxembourg", "Malta", "Monaco", "Netherlands", "Norway", "Poland", "Portugal", "Romania", "San Marino", "Saudi Arabia", "Singapore", "Slovakia", "Slovenia", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      score: "4.6",
      lose: "74-89",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: fpmarket,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "1 – 4 Days",
          InactiveFee: 0,
          IslamicAccount: "yes",
          MT4: "yes",
          MT5: "no",
          TradingView: "yes",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "yes",
          AutochartistAccess: "yes",
          TradingCenteralAccess: "yes",
        },
      ],
      Safety: [
        {
          Toptierregulators: "ASIC, CySEC, FSCA, FSC-Mauritius",
          Funding_Methods:
            "Visa/Master/ Card, Bank Transfer, Skrill, Neteller, Paypal",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$50",
          MaximumLeverage:
            "500:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "MultiBank",
      url: "https://multibankfx.com",
      Country: ['AllCountry', "American Samoa", "Israel", "Albania", "Afghanistan", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      score: "4.6",
      lose: "74-89",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: multibank,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "2H – 1 Day",
          InactiveFee: 60,
          IslamicAccount: "yes",
          MT4: "yes",
          MT5: "yes",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "yes",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators:
            "ASIC, BaFin, CIMA, CySEC, SCA, FSC, FMA, MAS, VFSC",
          Funding_Methods: "Visa/Master Card, Bank Transfer, Skrill, Neteller",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$50",
          MaximumLeverage:
            "500:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "Eightcap",

      url: "https://www.eightcap.com",
      Country: ['AllCountry', "Angola", "Aruba", "Oman", "Egypt", "Bangladesh", "American Samoa", "Behrain", "China", "Kuwait", "Armenia", "Algeria", "Argentina", "Saudi Arabia", "Italy", "Albania", "Andorra", "Anguilla", "Antigua & Barbuda", "Australia", "Austria", "Belgium", "Brazil", "Denmark", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Luxembourg", "Netherlands", "New Zealand", "Poland", "Singapore", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      score: "4.6",
      lose: "77.78",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: Eightcap,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "1 – 2 Days",
          InactiveFee: 0,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "yes",
          TradingView: "yes",
          cTrader: "no",
          capitaliseaiAvailable: "yes",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "	FCA, FSCA, VFSC, ASIC",
          Funding_Methods:
            "Visa/Master Card, Bank Transfer, Skrill, Neteller Crypto",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$100",
          MaximumLeverage:
            "500:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "Vantage",
      Country: ['AllCountry', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda',
        'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Belgium', 'Brazil',
        'Cyprus', 'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy',
        'Kuwait', 'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore',
        'South Africa', 'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ]
      ,
      url: "https://www.vantagemarkets.com",
      score: "4.6",
      lose: "74-89",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: vintage,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "1 – 2 Days",
          InactiveFee: 0,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "yes",
          TradingView: "yes",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "yes",
          copyTradingAvailable: "yes",
          AutochartistAccess: "yes",
          TradingCenteralAccess: "yes",
        },
      ],
      Safety: [
        {
          Toptierregulators: "FCA, FSCA, VFSC, ASIC",
          Funding_Methods: "Visa/Master Card, Neteller, Skrill, Bank Transfer",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$50",
          MaximumLeverage:
            "500:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "HYCM",
      url: "https://hycm.com",
      Country: ['AllCountry', "Israel", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "Germany", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      score: "4.6",
      lose: "74-89",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: Hycmlogo,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "1 free per month",
          DepositFee: "1 – 3 Days",
          InactiveFee: 10,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "yes",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "	FCA, CySEC, CIMA, SVG",
          Funding_Methods:
            "Visa /Master Card, Bank Transfer, Skrill, Neteller, Crypto",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$100",
          MaximumLeverage:
            "500:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "HF Markets",
      Country: ['AllCountry', "United Arab Emirates"
        , "United Kingdom"],
      url: "https://www.hfm.com",
      score: "4.6",
      lose: "74.14",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: HFmarket,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "10H – 1 Day",
          InactiveFee: 5,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "yes",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "yes",
          AutochartistAccess: "yes",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "CMA, FSA, FSCA, DFSA, FCA, SVG",
          Funding_Methods: "Visa/Master Card, Bank Transfer, Skrill, Neteller",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$5",
          MaximumLeverage:
            "2000:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "Moneta Markets",
      Country: ['AllCountry', "Andorra", "Algeria", "Angola", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Brazil", "China", "Denmark", "Egypt", "Finland", "Germany", "Hong Kong", "Ireland", "Israel", "Italy", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Sweden", "Switzerland", "United Arab Emirates"],
      url: "	https://www.monetamarkets.com",
      score: "4.6",
      lose: "74-89",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: monetamarket,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "	1 free per month",
          DepositFee: "3H – 1 Day	",
          InactiveFee: 0,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "yes",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "yes",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "FSCA	",
          Funding_Methods: "Visa/Master Card, Bank Transfer, Sticpay",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$50",
          MaximumLeverage:
            "1000:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "Go Markets",
      url: "https://www.gomarkets.com",
      Country: ['AllCountry', "Luxembourg", "Oman", "Egypt", "Bangladesh", "Brazil", "Cyprus", "Ireland", "Denmark", "Austria", "Netherlands", "Behrain", "Hong Kong", "Armenia", "Angola", "Aruba", "Antigua & Barbuda", "Albania", "Andorra", "Argentina", "Algeria", "Poland", "Sweden", "Japan", "Italy", "Australia", "France", "Finland", "Germany", "United Kingdom", "Kuwait", "South Africa", "Saudi Arabia", "United Arab Emirates", "New Zealand"]
      ,
      score: "4.6",
      lose: "74-89",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: gomarket,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "Depends on method",
          DepositFee: "3H – 1 Day",
          InactiveFee: 0,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "yes",
          TradingView: "no",
          cTrader: "yes",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "yes",
          AutochartistAccess: "yes",
          TradingCenteralAccess: "yes",
        },
      ],
      Safety: [
        {
          Toptierregulators: "	ASIC, FSC-Mauritius",
          Funding_Methods: "Visa/Master Card, Bank Transfer, Skrill, Neteller",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$200",
          MaximumLeverage:
            "500:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "Markets.com",
      url: "https://www.markets.com",
      Country: ['AllCountry', "Saudi Arabia", "Egypt", "Albania", "Andorra", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Iceland", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      score: "4.6",
      lose: "67.7",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: marketcom,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "	$0",
          DepositFee: "4H – 1 Day",
          InactiveFee: 10,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "yes",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "ASIC, CySEC, FSCA, FCA, FSC",
          Funding_Methods: "Visa/Master Card, Bank Transfer, Skrill, Neteller",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$100",
          MaximumLeverage:
            "300:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "FXTM",
      url: "https://www.forextime.com",
      Country: ['AllCountry', "Afghanistan", "Israel", "Algeria", "Albania", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Brazil", "China", "Egypt", "Iceland", "Kuwait", "New Zealand", "Norway", "Oman", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      score: "4.6",
      lose: "81",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: fxtm,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$5",
          DepositFee: "5H – 1 Day",
          InactiveFee: 5,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "yes",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "CySEC, FSC-Mauritius",
          Funding_Methods:
            "Visa/Master Card, Bank Transfer, Skrill, Neteller, Perfect Money",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$10",
          MaximumLeverage:
            "2000:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "Trade Nation",
      Country: ['AllCountry', 'Albania', 'Algeria', 'Andorra', 'Anguilla', 'Antigua & Barbuda',
        'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Brazil', 'China',
        'Cyprus', 'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Japan',
        'Kuwait', 'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore',
        'South Africa', 'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ]
      ,
      url: "https://tradenation.com",
      score: "4.6",
      lose: "74-89",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: tradenation,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "2H – 1 Day",
          InactiveFee: 0,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "no",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "yes",
          AutochartistAccess: "no",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "ASIC, FCA, SCB, FSCA, FSA",
          Funding_Methods: "Visa/Master Card, Bank Transfer, Skrill",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$0",
          MaximumLeverage:
            "200:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "BlackBull",
      url: "https://blackbull.com",
      Country: ['AllCountry',
        'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Argentina',
        'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Belgium', 'Brazil', 'China', 'Cyprus',
        'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Kuwait',
        'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore', 'South Africa',
        'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ],
      score: "4.6",
      lose: "74-89",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: blackbull,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee: "$0",
          DepositFee: "1 – 2 Days",
          InactiveFee: 0,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "yes",
          TradingView: "yes",
          cTrader: "yes",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "yes",
          copyTradingAvailable: "yes",
          AutochartistAccess: "yes",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "FMA, FSA, FCA",
          Funding_Methods:
            "Visa/Master Card, Bank Transfer, Skrill, Neteller, Crypto, AstroPay",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$10",
          MaximumLeverage:
            "500:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "TMGM",
      url: "https://www.tmgm.com",
      Country: ['AllCountry',
        'Afghanistan', 'Albania', "Israel", 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda',
        'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Belgium', 'Brazil', 'China',
        'Cyprus', 'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Japan',
        'Kuwait', 'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Poland', 'Qatar', 'Singapore',
        'South Africa', 'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ],
      score: "4.6",
      lose: "74-89",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: tmgm,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee:
            "FCA in the UK, BaFin in Germany, and ASIC in Australia",
          DepositFee: "1 – 3 Days",
          InactiveFee: 30,
          IslamicAccount: "no",
          MT4: "yes",
          MT5: "no",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "no",
          AutochartistAccess: "no",
          TradingCenteralAccess: "yes",
        },
      ],
      Safety: [
        {
          Toptierregulators: "ASIC, FMA, VFSC",
          Funding_Methods:
            "Visa/Master Card, Bank Transfer, Skrill, Neteller, Crypto, Sticpay",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$100",
          MaximumLeverage:
            "500:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },
    {
      BrokerName: "Axi",
      Country: ['AllCountry',
        "Afghanistan",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antigua & Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Bahrain",
        "Bangladesh",
        "Belgium",
        "Brazil",
        "China",
        "Cyprus",
        "Denmark",
        "Egypt",
        "Finland",
        "France",
        "Germany",
        "Hong Kong",
        "Ireland",
        "Israel",
        "Italy",

        "Kuwait",

        "Netherlands",
        "New Zealand",
        "Oman",
        "Poland",
        "Qatar",
        "Saudi Arabia",
        "Singapore",
        "South Africa",
        "Spain",
        "Sweden",
        "Switzerland",
        "United Arab Emirates",
        "United Kingdom"
      ],
      url: "https://www.axi.com",
      score: "4.6",
      lose: "83.1",
      Avaiable: "in pakistan",
      Updated: "OCT 2023",
      img: axi,
      tradingfees: [
        {
          OverallScore: "3.9",
          FeeScore: "4.6",
          USstock: "$15",
          EURUSDspread: "$0.6",
          USstockindexoptions: "$10",
          SP500indexCFDfee: "$10",
        },
      ],
      Nontradingfees: [
        {
          WithdrawlFee:
            "FCA in the UK, BaFin in Germany, and ASIC in Australia",
          DepositFee: "1 – 3 Days",
          InactiveFee: 10,
          IslamicAccount: "yes",
          MT4: "yes",
          MT5: "no",
          TradingView: "no",
          cTrader: "no",
          capitaliseaiAvailable: "no",
          zuluTradeAvaiable: "no",
          copyTradingAvailable: "yes",
          AutochartistAccess: "yes",
          TradingCenteralAccess: "no",
        },
      ],
      Safety: [
        {
          Toptierregulators: "	ASIC, FCA, FSCA, FMA, DFSA, SVG",
          Funding_Methods:
            "Credit/Debit Card Bank Transfer,Neteller Skrill,Astropay",
          Investorprotection: "yes",
        },
      ],
      DepositandWithdrawal: [
        {
          Minimumdeposit:
            "$0",
          MaximumLeverage:
            "500:1",
          PayPalfordeposit: "yes",
          Wisefordeposit: "yes",
          Revolutfordeposit: "yes",
          Otherelectronicwallets: "yes",
        },
      ],
      PlatformandExperience: [
        {
          mobileplatformscore: "3.8",
          WebPlatformscore: "2.8",
          metatraderscore: "yes",
          custumservicescore: "4.5",
          Accountoppeningscore: "5.0",
        },
      ],
    },

  ];
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const swiperRef = useRef(null);

  const [selectedBroker, setSelectedBroker] = useState([]);
  const [isfixed, setIsfixed] = useState(false);



  const [SelectCountry, setSelectedCountry] = useState();
  // const [userData, setUserData] = useState(null);
  console.log('SelectCountry---->', SelectCountry);
  const countryCodes = {
    'AF': 'Afghanistan',
    'AL': 'Albania',
    'AE': 'United Arab Emirates',
    'DZ': 'Algeria',
    'AS': 'American Samoa',
    'AD': 'Andorra',
    'AO': 'Angola',
    'AI': 'Anguilla',
    'AG': 'Antigua and Barbuda',
    'AR': 'Argentina',
    'AM': 'Armenia',
    'AW': 'Aruba',
    'AU': 'Australia',
    'AT': 'Austria',
    'BH': 'Bahrain',
    'BD': 'Bangladesh',
    'BE': 'Belgium',
    'BR': 'Brazil',
    'CN': 'China',
    'CY': 'Cyprus',
    'DK': 'Denmark',
    'EG': 'Egypt',
    'FI': 'Finland',
    'FR': 'France',
    'DE': 'Germany',
    'HK': 'Hong Kong',
    'IE': 'Ireland',
    'IL': 'Israel',
    'IT': 'Italy',
    'JP': 'Japan',
    'KW': 'Kuwait',
    'LU': 'Luxembourg',
    'NL': 'Netherlands',
    'NZ': 'New Zealand',
    'OM': 'Oman',
    'PL': 'Poland',
    'QA': 'Qatar',
    'SA': 'Saudi Arabia',
    'SG': 'Singapore',
    'ZA': 'South Africa',
    'ES': 'Spain',
    'SE': 'Sweden',
    'CH': 'Switzerland',
    'UAE': 'United Arab Emirates',
    'GB': 'United Kingdom',
    'PK': 'AllCountry',
    'US': 'AllCountry',
    'RU': 'AllCountry',
    'TR': 'AllCountry',
    'IN': 'AllCountry',
    'CA': 'AllCountry',
    'MX': 'AllCountry',
    'NG': 'AllCountry',
  };

  // useEffect(() => {
  //   const condition = userData && Object.values(countryCodes).includes(userData) ? userData : "AllCountry";
  //   setSelectedCountry(condition);
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [userData]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://ipinfo.io/json?token=dec4b91441eb65');
        const data = await response.json();
        const fullCountry = countryCodes[data.country];
        // console.log(countryCodes[data.country],"countryCodes[data.country]")
        // setUserData(fullCountry || data.country);
        // const condition = fullCountry ? fullCountry : "AllCountry";
        const condition = fullCountry && Object.values(countryCodes).includes(fullCountry) ? fullCountry : "AllCountry";
        setSelectedCountry(condition);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [activeSlidesData2, setActiveSlidesData2] = useState(null);
  const [filteredData, setfilteredData] = useState([]);
  const handleChange = (selectedOptions) => {
    setSelectedBroker(selectedOptions);
  };
  const handleCountry = (event) => {
    const selectedValue = event.value;
    setSelectedCountry(selectedValue);
    console.log(selectedValue, "<====handleCountry");
  };
  // const selectedCountry = country; 
  const selectedBrokers = BrokerDatas.filter(broker => broker.Country?.includes(SelectCountry));
  console.log(selectedBrokers, "<===selectedBrokers");
  
  // console.log(filteredData);
  useEffect(() => {
    const selectedValues = selectedBroker.map((selected) =>
      selected.value.toLowerCase()
    );

    const filteredData = BrokerDatas.filter((broker) =>
      selectedValues.includes(broker.BrokerName.toLowerCase())
    );

    setfilteredData(filteredData);
    if (filteredData.length > 0) {
      setActiveSlidesData([]);
      setActiveSlidesData2(filteredData);
    } else {
      
      const selectedBrokers = BrokerDatas.filter(broker => broker.Country?.includes(SelectCountry));
      setActiveSlidesData2(null);
      console.log(selectedBrokers.slice(0, 3) ,"<--Yes")
      setActiveSlidesData(selectedBrokers.slice(0, 3));
    }
    // eslint-disable-next-line
  }, [selectedBroker]);
  // console.log(selectedBroker);
  const [activeSlidesData, setActiveSlidesData] = useState([
    selectedBrokers[0],
    selectedBrokers[1],
    selectedBrokers[2],
    selectedBrokers[3],
    selectedBrokers[4],
  ]);
  const goNext = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const handleSlideChange = (swiper) => {
    const activeIndexes = [
      swiper.realIndex,
      swiper.realIndex + 1,
      swiper.realIndex + 2,
      swiper.realIndex + 3,
      // swiper.realIndex + 4,
    ];
    if (filteredData.length === 0) {
  const selectedBrokers = BrokerDatas.filter(broker => broker.Country?.includes(SelectCountry));

      setActiveSlidesData(
        selectedBrokers.slice(activeIndexes[0], activeIndexes[0] + 3)
      );
    } else {
      setActiveSlidesData(null);
      setActiveSlidesData2(
        filteredData.slice(
          activeIndexes[0],
          activeIndexes[0] + filteredData.length
        )
      );
    }
  };

  const options = BrokerDatas?.filter(broker => broker.Country?.includes(SelectCountry)).map((e) => {
    return { label: `${e?.BrokerName}`, value: e?.BrokerName };
  });
  useEffect(() => {
    const handleScroll = () => {
      const scrollAmount1 = 280;
      const scrollAmount2 = 1500;
      const scrollY = window.pageYOffset;

      if (scrollY >= scrollAmount1 && scrollY < scrollAmount2) {
        setIsfixed(true);
      } else {
        setIsfixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const selectStyles = {
    control: (provided) => ({
      ...provided,
      width: "435px", 
      
      "@media (max-width: 600px)": {
        width: "320px"
      }
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      "@media (max-width: 600px)": {
        width: "320px"
      }
    })
  };
  const minRating = 0.1;
  const maxRating = 5.0;
  return (
    <div>
      <Header />
      {SelectCountry ?
        <>

          <section className="comparebroker container-fluid py-5">
            <div className="row">
              <div className="col-lg-4 col-md-6 mt-3 mb-3 posi" >
                <p className="input-label fw-bold">Select Country</p>
                <Select
                  styles={selectStyles}
                  options={countries}
                  defaultValue={{ label: SelectCountry, value: SelectCountry }}
                  onChange={handleCountry}

                />

                {" "}
              </div>
            </div>
            <div className="d-flex w-100 justify-content-center pb-4">

              <div className="select-group">
                {/* <div className={isfixed ? "fixed-div" : "left-2"}> */}
                <div>
                  <h4 className="text-center">Select Your Broker to Compare</h4>
                  <Select
                    onChange={handleChange}
                    isMulti={true}
                    isSearchable={true}
                    value={selectedBroker}
                    styles={selectStyles}
                    options={options}
                  />
                </div>
              </div>
            </div>
            <div className="swiper-broker w-100">
              <div className="border-0 border-lg-bottom border-slate-200 py-2 flex mx-auto max-w-screen-2xl px-3">
                <div className="flex-1" />
                <div className="flex-1 d-lg-none" />
                <div className="d-flex align-items-center w-100 py-1">
                  <div className="d-flex justify-content-between mx-auto items-center w-100 gap-4 d-lg-gap-4 d-lg-justify-content-center d-lg-w-auto align-items-center">
                    <button
                      type="button"
                      className="h-11 w-11 d-lg-h-7 d-lg-w-7 d-flex justify-content-center align-items-center p-1"
                      style={{
                        background: "transparent",
                        outline: "none",
                        border: "none",
                       
                      }}
                      onClick={goPrev}
                    >
                      <div className="h-7 w-7 rounded-circle border border-slate-300 d-flex justify-content-center align-items-center p-0">
                        <BiLeftArrowAlt
                          style={{
                            fontSize: "35px",
                            background: "aliceblue",
                            padding: "7px",
                            borderRadius: "20px",
                          }}
                        />
                      </div>
                    </button>
                    <div className="text-sm font-normal text-slate-600 d-lg-none">
                      16 - 20 of 32 items
                    </div>
                    <div className="d-lg-block text-sm font-normal text-white text-center">
                      <span className="font-weight-bold text-white">16</span>-
                      <span className="font-weight-bold text-white">20</span> brokers (out of{" "}
                      <span className="font-weight-bold">{selectedBrokers.length}</span> available in{" "}
                      <span className="text-capitalize">{SelectCountry}</span>)
                    </div>
                    <button
                      type="button"
                      className="p-2 "
                      style={{
                        background: "transparent",
                        outline: "none",
                        border: "none",
                      }}
                      onClick={goNext}
                    >
                      <div className="h-7 w-7 rounded-circle border border-slate-300 d-flex justify-content-center align-items-center p-0">
                        <BiRightArrowAlt
                          style={{
                            fontSize: "35px",
                            background: "aliceblue",
                            padding: "7px",
                            borderRadius: "20px",
                          }}
                        />
                      </div>
                    </button>
                  </div>
                  <div className="d-flex justify-content-center position-absolute bottom-1.5 d-lg-static d-lg-bottom-0">
                    <div
                      className="d-flex gap-2 align-items-center justify-content-center overflow-hidden"
                      style={{ maxWidth: 60 }}
                    >
                      <div className="rounded-circle bg-secondary shrink-0 opacity-30 w-1.5 h-1.5" />
                      <div className="rounded-circle bg-secondary shrink-0 transition-height duration-200 opacity-30 w-1.5 h-1.5" />
                      <div className="rounded-circle bg-secondary shrink-0 transition-height duration-200 opacity-30 w-2 h-2" />
                      <div className="rounded-circle bg-secondary shrink-0 transition-height duration-200 opacity-100 w-2 h-2" />
                      <div className="rounded-circle bg-secondary shrink-0 transition-height duration-200 opacity-30 w-2 h-2" />
                      <div className="rounded-circle bg-secondary shrink-0 transition-height duration-200 opacity-30 w-1.5 h-1.5" />
                      <div className="rounded-circle bg-secondary shrink-0 opacity-30 w-1.5 h-1.5" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex-1 d-flex justify-content-end align-items-center gap-4" />

              <div className="row py-5 mx-2">
                <Swiper
                  ref={swiperRef}
                  slidesPerView={3}
                  spaceBetween={10}
                  onSlideChange={(swiper) => handleSlideChange(swiper)}
                  breakpoints={{
                    300: {
                      slidesPerView: 1,
                      spaceBetween: 20,
                    },
                    640: {
                      slidesPerView: 1,
                      spaceBetween: 20,
                    },
                    768: {
                      slidesPerView: 2,
                      spaceBetween: 40,
                    },
                    1024: {
                      slidesPerView: 3,
                      spaceBetween: 100,
                    },
                  }}
                  navigation={true}
                  allowTouchMove={false}
                  className="mySwiper "
                >
                  {filteredData.length === 0
                    ? selectedBrokers.map((e, i) => (
                      <SwiperSlide key={i}>
                        <div className="slide-wrap">
                          <div className="d-flex flex-column align-items-center">

                            <span onClick={() => window.open(`${e?.url}`, "_blank")} className="cursor-pointer">
                              <img
                                src={e?.img}
                                width={"60"}
                                height={"60"}
                                className="rounded-2 shadow-lg"
                                alt=""
                              />
                            </span>
                            <h6 className="text-center py-3">{e?.BrokerName}</h6>

                            <div></div>
                            <div className="link-btn">
                              <span
                                onClick={() => window.open(`${e?.url}`, '_blank')}
                                className="theme-btn btn-style-two cursor-pointer"
                              >

                                <span className="btn-title">VISIT BROKER {" "}<LuExternalLink size='22' style={{ paddingBottom: "5px" }} /></span>
                              </span>
                            </div>
                            <div className="hint">
                              <p className="tradepara py-1 my-3">
                                {`${e?.lose}% of retail CFD accounts lose money `}
                              </p>
                            </div>
                          </div>
                          <div className="slider-content">
                            <div className="d-flex flex-column align-items-center justify-content-center">
                              <div>
                                <h6>Overall Score</h6>
                              </div>

                              <div className="d-flex mainbar justify-content-center gap-2">
                                <div className="progress-bar">
                                  <div
                                    className="progress-fill"
                                    style={{
                                      width: `${(e?.tradingfees.reduce((acc, fee) => {
                                        const score = parseFloat(
                                          fee?.OverallScore
                                        );
                                        if (!isNaN(score)) {
                                          return acc + (score - minRating);
                                        } else {
                                          return acc;
                                        }
                                      }, 0) /
                                        (maxRating - minRating)) *
                                        100
                                        }%`,
                                    }}
                                  ></div>
                                </div>

                                <p>
                                  {e?.tradingfees.map((e) => e?.OverallScore)}
                                </p>
                              </div>
                            </div>
                            <div className="d-flex flex-column align-items-center justify-content-center ">
                              <div>
                                <h6>Fee Score</h6>
                              </div>

                              <div className="d-flex mainbar justify-content-center gap-2">
                                <div className="progress-bar">
                                  <div
                                    className="progress-fill"
                                    style={{
                                      width: `${(e?.tradingfees.reduce((acc, fee) => {
                                        const score = parseFloat(fee?.FeeScore);
                                        if (!isNaN(score)) {
                                          return acc + (score - minRating);
                                        } else {
                                          return acc;
                                        }
                                      }, 0) /
                                        (maxRating - minRating)) *
                                        100
                                        }%`,
                                      backgroundColor: "#08bb68",
                                    }}
                                  ></div>
                                </div>

                                <p>{e?.tradingfees.map((e) => e?.FeeScore)}</p>
                              </div>
                            </div>
                            <div className="slider-content">
                              <div className="d-flex flex-column align-items-center justify-content-center">
                                <div>
                                  <h6 className="text-center">
                                    Educational Tools Score
                                  </h6>
                                </div>

                                <div className="d-flex mainbar justify-content-center gap-2">
                                  <div className="progress-bar">
                                    <div
                                      className="progress-fill"
                                      style={{
                                        width: `${(e?.PlatformandExperience.reduce(
                                          (acc, fee) => {
                                            const score = parseFloat(
                                              fee?.mobileplatformscore
                                            );
                                            if (!isNaN(score)) {
                                              return acc + (score - minRating);
                                            } else {
                                              return acc;
                                            }
                                          },
                                          0
                                        ) /
                                          (maxRating - minRating)) *
                                          100
                                          }%`,
                                        backgroundColor: "#08bb68",
                                      }}
                                    ></div>
                                  </div>
                                  <p>
                                    {e?.PlatformandExperience.map(
                                      (e) => e?.mobileplatformscore
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="slider-content">
                              <h6 className="text-center">
                                Account Processing Time
                              </h6>

                              <p className="text-center  option-para">
                                {e?.Nontradingfees.map((e) => e?.DepositFee)}
                              </p>
                            </div>
                            {/* <div className="slider-content">
                <h6 className="text-center">Withdrawl Fee</h6>
                <p className="text-center  option-para">
                  {e?.Nontradingfees.map((e) => e?.WithdrawlFee)}
                </p>
              </div> */}

                            <div className="slider-content">
                              <h6 className="text-center">Regulations</h6>
                              <p className="text-center  option-para">
                                {e?.Safety.map((e) => e?.Toptierregulators)}
                              </p>
                            </div>
                            <div className="slider-content">
                              <h6 className="text-center">Funding Methods</h6>
                              <p className="text-center  option-para">
                                {e?.Safety.map((e) => e?.Funding_Methods)}
                              </p>
                            </div>
                            <div className="slider-content">
                              <h6 className="text-center">Minimium Deposit</h6>
                              <p className="text-center  option-para option-para">
                                {e?.DepositandWithdrawal.map(
                                  (e) => e?.Minimumdeposit
                                )}
                              </p>
                            </div>
                            <div className="slider-content">
                              <h6 className="text-center">Withdrawal Fee</h6>
                              <p className="text-center  option-para">
                                {e?.Nontradingfees.map((e) => e?.WithdrawlFee)}
                              </p>
                            </div>
                            <div className="slider-content">
                              <h6 className="text-center">Maximum Leverage</h6>
                              <p className="text-center  option-para">
                                {e?.DepositandWithdrawal.map(
                                  (e) => e?.MaximumLeverage
                                )}
                              </p>
                            </div>
                            {/* <div className="slider-content">
                            <h6 className="text-center">Investor Protection</h6>
                            <p className="text-center  option-para">
                              {e?.Safety.map((e) =>
                                e?.Investorprotection === "yes" ? (
                                  <BsCheck2Circle
                                    style={{ fontSize: "32px", color: "green" }}
                                  />
                                ) : (
                                  <SlClose
                                    style={{ fontSize: "32px", color: "red" }}
                                  />
                                )
                              )}
                            </p>
                          </div> */}
                            <div className="slider-content">
                              <h6 className="text-center">Inactivity Fee</h6>
                              <p className="text-center  option-para">
                                {e?.Nontradingfees.map((e) =>
                                  e?.InactiveFee > 0 ? (
                                    <BsCheck2Circle
                                      style={{ fontSize: "32px", color: "green" }}
                                    />
                                  ) : (
                                    <SlClose
                                      style={{ fontSize: "32px", color: "red" }}
                                    />
                                  )
                                )}
                              </p>
                            </div>
                            <div className="slider-content">
                              <h6 className="text-center">Islamic Account</h6>
                              <p className="text-center  option-para">
                                {e?.Nontradingfees.map((e) =>
                                  e?.IslamicAccount === "yes" ? (
                                    <BsCheck2Circle
                                      style={{ fontSize: "32px", color: "green" }}
                                    />
                                  ) : (
                                    <SlClose
                                      style={{ fontSize: "32px", color: "red" }}
                                    />
                                  )
                                )}
                              </p>
                            </div>
                            <div className="slider-content">
                              <h6 className="text-center">MT4 Avaiable</h6>
                              <p className="text-center  option-para">
                                {e?.Nontradingfees.map((e) =>
                                  e?.MT4 === "yes" ? (
                                    <BsCheck2Circle
                                      style={{ fontSize: "32px", color: "green" }}
                                    />
                                  ) : (
                                    <SlClose
                                      style={{ fontSize: "32px", color: "red" }}
                                    />
                                  )
                                )}
                              </p>
                            </div>
                            <div className="slider-content">
                              <h6 className="text-center">MT5 Avaiable</h6>
                              <p className="text-center  option-para">
                                {e?.Nontradingfees.map((e) =>
                                  e?.MT5 === "yes" ? (
                                    <BsCheck2Circle
                                      style={{ fontSize: "32px", color: "green" }}
                                    />
                                  ) : (
                                    <SlClose
                                      style={{ fontSize: "32px", color: "red" }}
                                    />
                                  )
                                )}
                              </p>
                            </div>
                            <div className="slider-content">
                              <h6 className="text-center">
                                TradingView Available
                              </h6>
                              <p className="text-center  option-para">
                                {e?.Nontradingfees.map((e) =>
                                  e?.TradingView === "yes" ? (
                                    <BsCheck2Circle
                                      style={{ fontSize: "32px", color: "green" }}
                                    />
                                  ) : (
                                    <SlClose
                                      style={{ fontSize: "32px", color: "red" }}
                                    />
                                  )
                                )}
                              </p>
                            </div>
                            <div className="slider-content">
                              <h6 className="text-center">cTrader Available</h6>
                              <p className="text-center  option-para">
                                {e?.Nontradingfees.map((e) =>
                                  e?.cTrader === "yes" ? (
                                    <BsCheck2Circle
                                      style={{ fontSize: "32px", color: "green" }}
                                    />
                                  ) : (
                                    <SlClose
                                      style={{ fontSize: "32px", color: "red" }}
                                    />
                                  )
                                )}
                              </p>
                            </div>
                            <div className="slider-content">
                              <h6 className="text-center">
                                Capitalise.ai Available
                              </h6>
                              <p className="text-center  option-para">
                                {e?.Nontradingfees.map((e) =>
                                  e?.capitaliseaiAvailable === "yes" ? (
                                    <BsCheck2Circle
                                      style={{ fontSize: "32px", color: "green" }}
                                    />
                                  ) : (
                                    <SlClose
                                      style={{ fontSize: "32px", color: "red" }}
                                    />
                                  )
                                )}
                              </p>
                            </div>
                            <div className="slider-content">
                              <h6 className="text-center">
                                Zulu Trade Available
                              </h6>
                              <p className="text-center  option-para">
                                {e?.Nontradingfees.map((e) =>
                                  e?.zuluTradeAvaiable === "yes" ? (
                                    <BsCheck2Circle
                                      style={{ fontSize: "32px", color: "green" }}
                                    />
                                  ) : (
                                    <SlClose
                                      style={{ fontSize: "32px", color: "red" }}
                                    />
                                  )
                                )}
                              </p>
                            </div>
                            <div className="slider-content">
                              <h6 className="text-center">
                                Copy Trading Available
                              </h6>
                              <p className="text-center  option-para">
                                {e?.Nontradingfees.map((e) =>
                                  e?.copyTradingAvailable === "yes" ? (
                                    <BsCheck2Circle
                                      style={{ fontSize: "32px", color: "green" }}
                                    />
                                  ) : (
                                    <SlClose
                                      style={{ fontSize: "32px", color: "red" }}
                                    />
                                  )
                                )}
                              </p>
                            </div>
                            <div className="slider-content">
                              <h6 className="text-center">Autochartist Access</h6>
                              <p className="text-center  option-para">
                                {e?.Nontradingfees.map((e) =>
                                  e?.AutochartistAccess === "yes" ? (
                                    <BsCheck2Circle
                                      style={{ fontSize: "32px", color: "green" }}
                                    />
                                  ) : (
                                    <SlClose
                                      style={{ fontSize: "32px", color: "red" }}
                                    />
                                  )
                                )}
                              </p>
                            </div>
                            <div className="slider-content">
                              <h6 className="text-center">
                                {" "}
                                Trading Centeral Access
                              </h6>
                              <p className="text-center  option-para">
                                {e?.Nontradingfees.map((e) =>
                                  e?.TradingCenteralAccess === "yes" ? (
                                    <BsCheck2Circle
                                      style={{ fontSize: "32px", color: "green" }}
                                    />
                                  ) : (
                                    <SlClose
                                      style={{ fontSize: "32px", color: "red" }}
                                    />
                                  )
                                )}
                              </p>
                              <div
                                className="hint"
                                style={{ textAlign: "center" }}
                              >
                                <a href="#" className="forhover">
                                  {" "}
                                  <span
                                    style={{
                                      borderBottom: "1px solid #0a2cd4",
                                      textAlign: "center",
                                    }}
                                  >
                                    Read review
                                  </span>{" "}
                                </a>
                                <div className="link-btn py-3">
                                  <span onClick={() => window.open("#")} className="theme-btn btn-style-two cursor-pointer">


                                    <span className="btn-title">VISIT BROKER {" "}<LuExternalLink size='22' style={{ paddingBottom: "5px" }} /></span>

                                  </span>
                                </div>
                                <p
                                  className="tradepara py-1 mt-2 mb-0"
                                  style={{ textAlign: "center" }}
                                >
                                  {`${e?.lose}% of retail CFD accounts lose money`}
                                </p>
                              </div>
                            </div>

                          </div>
                        </div>
                      </SwiperSlide>
                    ))
                    : null}
                  {filteredData.map((e, i) => (
                    <SwiperSlide key={i} >
                      <div className="slide-wrap">
                        <div className="d-flex flex-column align-items-center">
                          <span className="cursor-pointer" onClick={() => window.open(`${e?.url}`, '_blank')} >
                            <img
                              src={e?.img}
                              width={"60"}
                              height={"60"}
                              className="rounded-2 shadow-lg"
                              alt=""
                            />
                          </span>
                          <h6 className="text-center py-3">{e?.BrokerName}</h6>

                          <div></div>
                          <div className="link-btn">
                            <span
                              onClick={() => window.open(`${e?.url}`, '_blank')}
                              className="theme-btn btn-style-two cursor-pointer"
                            >
                              <span className="btn-title">VISIT BROKER {" "}<LuExternalLink size='22' style={{ paddingBottom: "5px" }} /></span>
                            </span>
                          </div>
                          <div className="hint">
                            <p className="tradepara py-3 my-3">
                              {`${e?.lose}% of retail CFD accounts lose money`}
                            </p>
                          </div>
                        </div>
                        <div className="slider-content">
                          <div className="d-flex flex-column align-items-center justify-content-center">
                            <div>
                              <h6>Overall Score</h6>
                            </div>

                            <div className="d-flex mainbar justify-content-center gap-2">
                              <div className="progress-bar">
                                <div
                                  className="progress-fill"
                                  style={{
                                    width: `${(e?.tradingfees.reduce((acc, fee) => {
                                      const score = parseFloat(fee?.OverallScore);
                                      if (!isNaN(score)) {
                                        return acc + (score - minRating);
                                      } else {
                                        return acc;
                                      }
                                    }, 0) /
                                      (maxRating - minRating)) *
                                      100
                                      }%`,
                                  }}
                                ></div>
                              </div>

                              <p>{e?.tradingfees.map((e) => e?.OverallScore)}</p>
                            </div>
                          </div>
                          <div className="d-flex flex-column align-items-center justify-content-center ">
                            <div>
                              <h6>Fee Score</h6>
                            </div>

                            <div className="d-flex mainbar justify-content-center gap-2">
                              <div className="progress-bar">
                                <div
                                  className="progress-fill"
                                  style={{
                                    width: `${(e?.tradingfees.reduce((acc, fee) => {
                                      const score = parseFloat(fee?.FeeScore);
                                      if (!isNaN(score)) {
                                        return acc + (score - minRating);
                                      } else {
                                        return acc;
                                      }
                                    }, 0) /
                                      (maxRating - minRating)) *
                                      100
                                      }%`,
                                    backgroundColor: "#08bb68",
                                  }}
                                ></div>
                              </div>

                              <p>{e?.tradingfees.map((e) => e?.FeeScore)}</p>
                            </div>
                          </div>
                          <div className="slider-content">
                            <div className="d-flex flex-column align-items-center justify-content-center">
                              <div>
                                <h6 className="text-center">
                                  Educational Tools Score
                                </h6>
                              </div>

                              <div className="d-flex mainbar justify-content-center gap-2">
                                <div className="progress-bar">
                                  <div
                                    className="progress-fill"
                                    style={{
                                      width: `${(e?.PlatformandExperience.reduce(
                                        (acc, fee) => {
                                          const score = parseFloat(
                                            fee?.mobileplatformscore
                                          );
                                          if (!isNaN(score)) {
                                            return acc + (score - minRating);
                                          } else {
                                            return acc;
                                          }
                                        },
                                        0
                                      ) /
                                        (maxRating - minRating)) *
                                        100
                                        }%`,
                                      backgroundColor: "#08bb68",
                                    }}
                                  ></div>
                                </div>
                                <p>
                                  {e?.PlatformandExperience.map(
                                    (e) => e?.mobileplatformscore
                                  )}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="slider-content">
                            <h6 className="text-center">Account Processing Time</h6>

                            <p className="text-center  option-para">
                              {e?.Nontradingfees.map((e) => e?.DepositFee)}
                            </p>
                          </div>
                          <div className="slider-content">
                            <h6 className="text-center">Withdrawl Fee</h6>
                            <p className="text-center  option-para">
                              {e?.Nontradingfees.map((e) => e?.WithdrawlFee)}
                            </p>
                          </div>

                          <div className="slider-content">
                            <h6 className="text-center">Regulations</h6>
                            <p className="text-center  option-para">
                              {e?.Safety.map((e) => e?.Toptierregulators)}
                            </p>
                          </div>
                          <div className="slider-content">
                            <h6 className="text-center">Funding Methods</h6>
                            <p className="text-center  option-para">
                              {e?.Safety.map((e) => e?.Funding_Methods)}
                            </p>
                          </div>
                          <div className="slider-content">
                            <h6 className="text-center">Minimium Deposit</h6>
                            <p className="text-center  option-para">
                              {e?.DepositandWithdrawal.map(
                                (e) => e?.Minimumdeposit
                              )}
                            </p>
                          </div>
                          <div className="slider-content">
                            <h6 className="text-center">Withdrawl Fee</h6>
                            <p className="text-center  option-para">
                              {e?.Nontradingfees.map((e) => e?.WithdrawlFee)}
                            </p>
                          </div>
                          <div className="slider-content">
                            <h6 className="text-center">Maximum Leverage</h6>
                            <p className="text-center  option-para">
                              {e?.DepositandWithdrawal.map(
                                (e) => e?.MaximumLeverage
                              )}
                            </p>
                          </div>
                          {/* <div className="slider-content">
                        <h6 className="text-center">Investor Protection</h6>
                        <p className="text-center  option-para">
                          {e?.Safety.map((e) =>
                            e?.Investorprotection === "yes" ? (
                              <BsCheck2Circle
                                style={{ fontSize: "32px", color: "green" }}
                              />
                            ) : (
                              <SlClose
                                style={{ fontSize: "32px", color: "red" }}
                              />
                            )
                          )}
                        </p>
                      </div> */}
                          <div className="slider-content">
                            <h6 className="text-center">Inactivity Fee</h6>
                            <p className="text-center  option-para">
                              {e?.Nontradingfees.map((e) =>
                                e?.InactiveFee > 0 ? (
                                  <BsCheck2Circle
                                    style={{ fontSize: "32px", color: "red" }}
                                  />
                                ) : (
                                  <SlClose
                                    style={{ fontSize: "32px", color: "green" }}
                                  />
                                )
                              )}
                            </p>
                          </div>
                          <div className="slider-content">
                            <h6 className="text-center">Islamic Account</h6>
                            <p className="text-center  option-para">
                              {e?.Nontradingfees.map((e) =>
                                e?.IslamicAccount === "yes" ? (
                                  <BsCheck2Circle
                                    style={{ fontSize: "32px", color: "green" }}
                                  />
                                ) : (
                                  <SlClose
                                    style={{ fontSize: "32px", color: "red" }}
                                  />
                                )
                              )}
                            </p>
                          </div>
                          <div className="slider-content">
                            <h6 className="text-center">MT4 Avaiable</h6>
                            <p className="text-center  option-para">
                              {e?.Nontradingfees.map((e) =>
                                e?.MT4 === "yes" ? (
                                  <BsCheck2Circle
                                    style={{ fontSize: "32px", color: "green" }}
                                  />
                                ) : (
                                  <SlClose
                                    style={{ fontSize: "32px", color: "red" }}
                                  />
                                )
                              )}
                            </p>
                          </div>
                          <div className="slider-content">
                            <h6 className="text-center">MT5 Avaiable</h6>
                            <p className="text-center  option-para">
                              {e?.Nontradingfees.map((e) =>
                                e?.MT5 === "yes" ? (
                                  <BsCheck2Circle
                                    style={{ fontSize: "32px", color: "green" }}
                                  />
                                ) : (
                                  <SlClose
                                    style={{ fontSize: "32px", color: "red" }}
                                  />
                                )
                              )}
                            </p>
                          </div>
                          <div className="slider-content">
                            <h6 className="text-center">TradingView Avaiable</h6>
                            <p className="text-center  option-para">
                              {e?.Nontradingfees.map((e) =>
                                e?.TradingView === "yes" ? (
                                  <BsCheck2Circle
                                    style={{ fontSize: "32px", color: "green" }}
                                  />
                                ) : (
                                  <SlClose
                                    style={{ fontSize: "32px", color: "red" }}
                                  />
                                )
                              )}
                            </p>
                          </div>
                          <div className="slider-content">
                            <h6 className="text-center">cTrader</h6>
                            <p className="text-center  option-para">
                              {e?.Nontradingfees.map((e) =>
                                e?.cTrader === "yes" ? (
                                  <BsCheck2Circle
                                    style={{ fontSize: "32px", color: "green" }}
                                  />
                                ) : (
                                  <SlClose
                                    style={{ fontSize: "32px", color: "red" }}
                                  />
                                )
                              )}
                            </p>
                          </div>
                          <div className="slider-content">
                            <h6 className="text-center">Capitalise.ai Available</h6>
                            <p className="text-center  option-para">
                              {e?.Nontradingfees.map((e) =>
                                e?.capitaliseaiAvailable === "yes" ? (
                                  <BsCheck2Circle
                                    style={{ fontSize: "32px", color: "red" }}
                                  />
                                ) : (
                                  <SlClose
                                    style={{ fontSize: "32px", color: "red" }}
                                  />
                                )
                              )}
                            </p>
                          </div>
                          <div className="slider-content">
                            <h6 className="text-center">zulu Trade Available</h6>
                            <p className="text-center  option-para">
                              {e?.Nontradingfees.map((e) =>
                                e?.zuluTradeAvaiable === "yes" ? (
                                  <BsCheck2Circle
                                    style={{ fontSize: "32px", color: "green" }}
                                  />
                                ) : (
                                  <SlClose
                                    style={{ fontSize: "32px", color: "red" }}
                                  />
                                )
                              )}
                            </p>
                          </div>
                          <div className="slider-content">
                            <h6 className="text-center">Copy Trading Available</h6>
                            <p className="text-center  option-para">
                              {e?.Nontradingfees.map((e) =>
                                e?.copyTradingAvailable === "yes" ? (
                                  <BsCheck2Circle
                                    style={{ fontSize: "32px", color: "green" }}
                                  />
                                ) : (
                                  <SlClose
                                    style={{ fontSize: "32px", color: "red" }}
                                  />
                                )
                              )}
                            </p>
                          </div>
                          <div className="slider-content">
                            <h6 className="text-center">Autochartist Access</h6>
                            <p className="text-center  option-para">
                              {e?.Nontradingfees.map((e) =>
                                e?.AutochartistAccess === "yes" ? (
                                  <BsCheck2Circle
                                    style={{ fontSize: "32px", color: "green" }}
                                  />
                                ) : (
                                  <SlClose
                                    style={{ fontSize: "32px", color: "red" }}
                                  />
                                )
                              )}
                            </p>
                          </div>
                          <div className="slider-content">
                            <h6 className="text-center">
                              {" "}
                              Trading Centeral Access
                            </h6>
                            <p className="text-center  option-para">
                              {e?.Nontradingfees.map((e) =>
                                e?.TradingCenteralAccess === "yes" ? (
                                  <BsCheck2Circle
                                    style={{ fontSize: "32px", color: "green" }}
                                  />
                                ) : (
                                  <SlClose
                                    style={{ fontSize: "32px", color: "red" }}
                                  />
                                )
                              )}
                            </p>
                            <div className="hint" style={{ textAlign: "center" }}>
                              <a href="#" className="forhover">
                                {" "}
                                <span
                                  style={{
                                    borderBottom: "1px solid #0a2cd4",
                                    textAlign: "center",
                                  }}
                                >
                                  Read review
                                </span>{" "}
                              </a>
                              <div className="link-btn py-3">
                                <a href="#" className="theme-btn btn-style-two">
                                  <span className="btn-title">VISIT BROKER</span>
                                </a>
                              </div>
                              <p
                                className="tradepara py-1 mt-2 mb-0"
                                style={{ textAlign: "center" }}
                              >
                                {`${e?.lose}% of retail CFD accounts lose money`}
                              </p>
                            </div>
                          </div>
                          {/*    <div className='d-flex flex-column align-items-center justify-content-center'>
            <h6>EURUSDspread</h6>

            <p className="text-center  option-para">
        

              {data?.tradingfees.map((e) => e?.EURUSDspread)}
            </p>
            </div>
            <div className='d-flex flex-column align-items-center justify-content-center'>
            <h6>USstockindexoptions</h6>
            <p className="text-center  option-para">
              {data?.tradingfees.map((e) => e?.USstockindexoptions)}
            </p>
            </div> */}
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </section>
          <div className={`${isfixed ? "position-fixed" : "makeitinvisible"}`}>
            <Swiper
              // ref={swiperRef2}
              slidesPerView={3}
              spaceBetween={10}
              breakpoints={{
                300: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                640: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
              }}
              navigation={true}
              allowTouchMove={false}
              className="mySwiper "
            >
            
            {console.log('activeSlidesData----->',activeSlidesData)}
              {activeSlidesData.length === 2
                ? selectedBrokers.slice(0,3).map((e, i) => (
                  <SwiperSlide key={i}>
                    <div className="slide-wrap">
                      <div className="d-flex flex-column align-items-center">
                        <span onClick={() => window.open(`${e?.url}`, '_blank')} className="cursor-pointer">

                          <img
                            src={e?.img}
                            width={"40"}
                            height={"40"}
                            className="rounded-2 shadow-lg"
                            alt=""
                          />
                        </span>
                        <h6 className="text-center py-1">{e?.BrokerName}</h6>

                        <div></div>
                        <div className="link-btn">
                          <span
                            onClick={() => window.open(`${e?.url}`, '_blank')}
                            className="theme-btn btn-style-two cursor-pointer"
                          >
                            <span className="btn-title">VISIT BROKER {" "}<LuExternalLink size='22' style={{ paddingBottom: "5px" }} /></span>
                          </span>
                        </div>
                        <div className="hint">
                          <p className="tradepara py-1 mt-2 mb-0">
                            {`${e?.lose}% of retail CFD accounts lose money `}
                          </p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))
                : activeSlidesData.map((e, i) => (
                  <SwiperSlide key={i}>
                    <div className="slide-wrap">
                      <div className="d-flex flex-column align-items-center">
                        <span onClick={() => window.open(`${e?.url}`, '_blank')} className="cursor-pointer">

                          <img
                            src={e?.img}
                            width={"40"}
                            height={"40"}
                            className="rounded-2 shadow-lg"
                            alt=""
                          />
                        </span>
                        <h6 className="text-center py-1">{e?.BrokerName}</h6>

                        <div></div>
                        <div className="link-btn">
                          <span
                            onClick={() => window.open(`${e?.url}`, '_blank')}
                            className="theme-btn btn-style-two cursor-pointer"
                          >
                            <span className="btn-title">VISIT BROKER {" "}<LuExternalLink size='22' style={{ paddingBottom: "5px" }} /></span>
                          </span>
                        </div>
                        <div className="hint">
                          <p className="tradepara py-1 mt-2 mb-0">
                            {`${e?.lose}% of retail CFD accounts lose money `}
                          </p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              {activeSlidesData2?.map((e, i) => (
                <SwiperSlide key={i}>
                  <div className="slide-wrap" >
                    <div className="d-flex flex-column align-items-center">
                      <a href={e?.url} target='_blank'>
                        <img
                          src={e?.img}
                          width={"40"}
                          height={"40"}
                          className="rounded-2 shadow-lg"
                          alt=""
                        />
                      </a>
                      <h6 className="text-center py-1">{e?.BrokerName}</h6>

                      <div></div>
                      <div className="link-btn">
                        <a href={e?.url} target='_blank' className="theme-btn btn-style-two">
                          <span
                            className="btn-title"
                            style={{
                              padding: "3px 7px",
                            }}
                          >
                            VISIT BROKER
                            <AiOutlineArrowRight />
                          </span>
                        </a>
                      </div>
                      <div className="hint">
                        <p className="tradepara py-1 mt-2 mb-0">
                          {`${e?.lose}% of retail CFD accounts lose money second`}
                        </p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </>

        :
        <div className="Loader">
        </div>
      }

      <Footer />
    </div>
  );
};

export default NewCompareBroker;
